export default "__VITE_ASSET__4eced57d__"